// extracted by mini-css-extract-plugin
export default {"wrapper":"switch-module--wrapper--Oo02P","disabled":"switch-module--disabled--wHJh-"};